// extracted by mini-css-extract-plugin
export var logo = "_ec-2";
export var logoWrapper = "_ec-1";
export var strip = "_ec-0";